
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.594 24a3.383 3.383 0 01-2.4-.993l-4.662-4.667a.482.482 0 010-.68l.878-.878a.479.479 0 000-.68l-1.568-1.568L4.07 23.29a2.401 2.401 0 01-3.656-.308 2.488 2.488 0 01.354-3.174l8.673-8.672-5.914-5.91a.485.485 0 00-.34-.141h-1.2a.484.484 0 01-.43-.265L.15 2a.473.473 0 01.09-.553L1.449.243A.477.477 0 012 .152l2.822 1.409a.48.48 0 01.265.43v1.2c0 .127.051.25.14.34l5.914 5.909 1.052-1.04a.482.482 0 00.11-.5 6.1 6.1 0 01-.156-3.311A6.02 6.02 0 0115.694.47a5.94 5.94 0 012.29-.47c.472 0 .942.058 1.4.172a.484.484 0 01.232.813L16.294 4.3a2.4 2.4 0 00.3 3.657c.387.277.852.425 1.329.421a2.637 2.637 0 001.854-.778l3.23-3.221a.488.488 0 01.818.231 5.822 5.822 0 01-.3 3.67 5.962 5.962 0 01-4.131 3.56c-.46.105-.929.159-1.4.159a6.023 6.023 0 01-1.925-.315.517.517 0 00-.16-.026.465.465 0 00-.331.135l-1.048 1.044 1.577 1.563a.478.478 0 00.68 0l.869-.869a.478.478 0 01.68 0l4.572 4.587a3.458 3.458 0 01.515 4.364A3.37 3.37 0 0120.593 24zm-18.22-3.606a1.2 1.2 0 10.001 2.4 1.2 1.2 0 000-2.4z"}})])
          )
        }
      }
    